import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { login } = useAuth();
  const navigate   = useNavigate();
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin() {
    setError('');
    setLoading(true);
    try {
      await login();
      navigate('/');
    } catch (err) {
      if (err.errorCode === 'user_cancelled') {
        setError('Login cancelled.');
      } else {
        setError(err.message || 'Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center"
      style={{ background: 'linear-gradient(135deg, #3D2B1A 0%, #2A1E12 50%, #1A1208 100%)' }}>

      {/* Background wave decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -bottom-20 -left-20 w-96 h-96 rounded-full opacity-10"
          style={{ background: '#E8761A' }} />
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full opacity-10"
          style={{ background: '#E8761A' }} />
      </div>

      <div className="relative w-full max-w-sm mx-4">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">

          {/* Header with logo */}
          <div className="px-8 pt-8 pb-6 text-center" style={{ background: 'linear-gradient(180deg, #3D2B1A, #2A1E12)' }}>
            <img src="/delair_logo.png" alt="Del-Air" className="h-16 object-contain mx-auto" />
            <div className="mt-3 text-xs font-semibold tracking-widest uppercase" style={{ color: '#E8761A' }}>
              P&CC Audit System
            </div>
          </div>

          {/* Body */}
          <div className="px-8 py-8">
            <h2 className="text-lg font-semibold text-gray-800 text-center mb-6">Sign in to continue</h2>

            {error && (
              <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                {error}
              </div>
            )}

            <button
              onClick={handleLogin}
              disabled={loading}
              className="w-full flex items-center justify-center gap-3 px-6 py-3 font-semibold rounded-xl text-white transition-all disabled:opacity-50 shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-100"
              style={{ background: loading ? '#b35c14' : 'linear-gradient(135deg, #E8761A, #c9600f)' }}
            >
              <svg className="w-5 h-5" viewBox="0 0 21 21" fill="none">
                <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
                <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
              </svg>
              {loading ? 'Signing in...' : 'Sign in with Microsoft'}
            </button>

            <p className="text-xs text-gray-400 text-center mt-6">
              Use your Del-Air Microsoft account to sign in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
